import axios from "axios";
//import axiosRetry from "axios-retry";

axios.defaults.baseURL = "/api/";
if (location.hostname === "localhost") {
  axios.defaults.baseURL = "http://localhost:9000";
}
axios.defaults.timeout = 600000;

export function createClient(token) {
  const instance = axios.create({
    headers: {
      token: token,
    },
  });

  //axiosRetry(instance, { retryDelay: axiosRetry.exponentialDelay });

  instance.interceptors.response.use((value) => {
    return value.data;
  });

  // Add streaming method for Server-Sent Events
  instance.postEventStream = async (url, data, options = {}) => {
    const baseURL = axios.defaults.baseURL;
    const fullUrl = baseURL + url;
    
    return fetch(fullUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "token": token,
        ...options.headers
      },
      body: JSON.stringify(data),
      signal: options.signal,
    });
  };

  return instance;
}
